module.exports = __webpack_public_path__ + "img/gsb.61754768.svg";